<template>
  <div>
    <label class="inlineFieldLabel">
      {{ label }}
      <span
        v-if="validation.$error"
        class="error"
      >Field is required</span>
    </label>
    <md-field>
      <md-input
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event)"
      />
    </md-field>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {
    value: {
      type: String, default: "", required: true
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String,
      default: ""
    },
    validation: {
      type: Object,
      default: () => ({ $error: false }),
      $error: {
        type: Boolean
      }
    }
  }
};
</script>

<style scoped>
.error {
  color: red;
  font-weight: 500;
}

.inlineFieldLabel {
  display: flex;
  justify-content: space-between;
  margin: 0 0 -20px;
}
</style>
